import type { AnyLayer } from 'mapbox-gl';

export const clusterLayerId = 'clusters';

export const unclusteredPointLayer: AnyLayer = {
  id: 'unclustered-point',
  type: 'circle',
  source: 'data-studies',

  filter: ['!', ['has', 'point_count']],

  paint: {
    'circle-radius-transition': { duration: 1000 },
    'circle-color': ['get', 'color'],
    'circle-radius': 12,
    'circle-stroke-width': 8,
    'circle-stroke-color': ['get', 'border'],
  },
};
